// extracted by mini-css-extract-plugin
export var active = "style-module--active--9643a";
export var activeLegendItem = "style-module--active-legend-item--a541d";
export var countrySelection = "style-module--country-selection--5402b";
export var filterHelptext = "style-module--filter-helptext--cdd5d";
export var flagContainer = "style-module--flag-container--b7a97";
export var graphLegend = "style-module--graph-legend--70bea";
export var graphWrapper = "style-module--graph-wrapper--b42e1";
export var iconWrapper = "style-module--icon-wrapper--432e0";
export var inactive = "style-module--inactive--95f6f";
export var legendBackground = "style-module--legend-background--148a2";
export var legendItem = "style-module--legend-item--f9860";
export var name = "style-module--name--b8817";
export var select = "style-module--select--4e64f";